/**
 *  * This is the configuration file
 *   */
export default {
  api_url: 'https://admin.onlygames.cl/api/v1/',
  image_url: 'https://admin.onlygames.cl/images/'
}



/** WEBPACK FOOTER **
 ** ./src/configure.js
 **/